import { Card, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerCard from "../../../common/components/BannerCard";
import { civilRequest } from "../../../state/connect-api";
import { useCivilCasePlaintiffMutation } from "../../../state/globalApi";
import { setCivilMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getConfigs from "../../../GetConfigs";

const CivilPlantiff = ({ ...props }) => {
  const [getCivilPlaintiff, { isLoading }] = useCivilCasePlaintiffMutation();
  const { activeCaseNumber, civilMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();

  useEffect(() => {
    const lookupRequest = civilRequest(activeCaseNumber);
    const fetch = async () => {
      const plaintiff = await getCivilPlaintiff(lookupRequest).unwrap();
      dispatch(setCivilMaster({ plaintiff: plaintiff }));
    };
    fetch();
  }, [activeCaseNumber, dispatch]);

  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctCVLPlaintiffTxt",
  ]);
  const columns = [
    { key: "name", dataIndex: "CaseParticipantName", title: "Name" },
    { key: "address", dataIndex: "PhysicalAddress1", title: "Address" },
    { key: "attorney", dataIndex: "AttorneyName", title: "Attorney" }
  ];

  return (
    <Row gutter={[16, 16]}>
      {configurations.ctCVLPlaintiffTxt && messageVisible && (
        <Col xl={23} lg={23} md={23} sm={23} xs={23}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: configurations.ctCVLPlaintiffTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <BannerCard title="Plaintiffs">
          <Table loading={isLoading} columns={columns} dataSource={civilMaster?.plaintiff?.LIST} scroll={{ x: 720 }} size="small" />
        </BannerCard>
      </Col>
    </Row>
  );
};

export default CivilPlantiff;
